import React from 'react';
import { base } from '../../helper/base-helper.js';
import { Icon, Container, Table, List, Divider, Button, Segment, Header } from 'semantic-ui-react';

import PublisherTableRow from './PublisherTableRow.js';

class Publisher extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      publishingStack: {},
    };
  }


  executePublishingStack = (e) => {
    const fanOutObj = {};

    Object.keys(this.state.publishingStack).forEach(objKey => {
      const {obj, rootNode} = this.state.publishingStack[objKey];
      fanOutObj[`/${rootNode}/${objKey}`] = {...obj};
    });

    // Need direct access of firebase's client side fanout to update multiple endpoints simultaneously
    base.database().ref().update(fanOutObj);

    this.setState({publishingStack:{}})
  };

  addToPublishingStack = (obj, rootNode) => {
    const publishingStack = {...this.state.publishingStack};
    publishingStack[obj.key] = {obj:obj ,rootNode};
    this.setState({publishingStack});

  };

  removeFromPublishingStack = (objKey) => {
    const publishingStack = {...this.state.publishingStack};
    delete publishingStack[objKey];
    this.setState({publishingStack});
  };

  renderTable = (channelKey) => {
    const channel = this.props.channels[channelKey];

    let tableRowArr = [];

    // 1. add the own channel table row
    tableRowArr.push(
      <PublisherTableRow key={channelKey} objKey={channelKey}
      rootNode={'channels'} rootData={this.props.channels}
      addToPublishingStack={this.addToPublishingStack} />
    )

    // 2. Iterate over actions build the table row and run
    // through nested iterator for actions requirements
    if(channel.actionId)
    channel.actionId.forEach(acyId => {
      const action = this.props.actions[acyId];

      tableRowArr.push(
        <PublisherTableRow key={acyId} objKey={acyId}
        rootNode={'actions'} rootData={this.props.actions}
        addToPublishingStack={this.addToPublishingStack} />);

        if(action.reqIds)
        action.reqIds.forEach(reqId => {
          tableRowArr.push(
            <PublisherTableRow key={reqId} objKey={reqId}
            rootNode={'requirements'} rootData={this.props.requirements}
            addToPublishingStack={this.addToPublishingStack} />);
        });
      });

    return (
      <Table key={channelKey} compact celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              style={{backgroundColor: `${channel.color}`}}
              colSpan={6}
              textAlign='center' >
              <Header size='small' inverted icon={channel.logo} content={channel.name} />
            </Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>Type</Table.HeaderCell>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Published</Table.HeaderCell>
            <Table.HeaderCell>Content Valid</Table.HeaderCell>
            <Table.HeaderCell>Key</Table.HeaderCell>
            <Table.HeaderCell>Add to Stack</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
      <Table.Body>

        { tableRowArr }

      </Table.Body>
      </Table>
    );
  }

  renderListItem = (stateObjKey) => {
    const {obj, rootNode} = this.state.publishingStack[stateObjKey];
    let objIcon = '';

    switch (rootNode) {
      case 'channels':
        objIcon = 'desktop';
        break;
      case 'actions':
        objIcon = 'lightbulb';
        break;
      case 'requirements':
        objIcon = 'ordered list';
        break;
      default:
        objIcon = 'question';
    }

    return (
      <List.Item key={obj.key} >
        <List.Content floated='right'>
          <Button compact basic negative icon='delete' onClick={(e) => this.removeFromPublishingStack(stateObjKey)} />
        </List.Content>
        <List.Content>
          <Icon name={objIcon} />
          <List horizontal >
            <List.Item>{obj.name}</List.Item>
            <List.Item>{`Published: ${obj.published}`}</List.Item>
            <List.Item>{`Key: ${obj.key}`}</List.Item>
          </List>
        </List.Content>
      </List.Item>
    )
  };

  render() {

    const stackIsEmpty = Object.keys(this.state.publishingStack).length === 0;

    return (
      <Container>
        <Segment>
          <List celled>
            <List.Header as='h2'>Stack for Published Process</List.Header>
            { Object.keys(this.state.publishingStack).map(this.renderListItem) }
          </List>
          <Divider />
          <Button
            content='Execute Stack'
            disabled={stackIsEmpty}
            onClick={(e) => this.executePublishingStack(e)}
          />
        </Segment>

        { Object.keys(this.props.channels).map(this.renderTable) }

      </Container>
    )
  }

}

export default Publisher;



// WEBPACK FOOTER //
// ./src/components/forms/Publisher.js